import { matchesPathname } from "@/lib/pathname";

export const GOOGLE_ONE_TAP_PROVIDER_ID = "google-one-tap" as const;

export function isGoogleOneTapAllowedPath(pathname: string): boolean {
  return (
    matchesPathname(pathname, "/login") ||
    matchesPathname(pathname, "/job-listings")
  );
}
